import React, { useRef } from "react";
import ModalWrapper from "./ModalWrapper";
import PropTypes from "prop-types";
import { confirmable } from "react-confirm";
import { createConfirmation } from "react-confirm";
const OptionsFormModal = ({ show, proceed, options = {} }) => {
  const formRef = useRef(null);

  if (show) {
    return (
      <ModalWrapper
        clickOff={() => {
          proceed(false);
        }}
      >
        <div
          className={`flex flex-col  rounded-xl bg-snow-white drop-shadow-2xl px-12 pt-6 pb-6 overflow-x-scroll justify-center`}
        >
          <p className="text-2xl font-bold font-snow-primary mb-2 text-center">
            {options.title ?? "Pick Options"}
          </p>
          <form ref={formRef}>{options.formElements}</form>
          <div className="flex flex-row flex-1 w-full gap-4 justify-center">
            <button
              onClick={() => {
                const formData = new FormData(formRef.current);
                const data = Object.fromEntries(formData.entries());
                proceed(data);
              }}
              className={`min-w-[100px] border rounded-md p-2 text-sm shadow-sm font-semibold bg-snow-blue-3 hover:bg-sky-700 text-full-white border-snow-blue-3`}
              type="button"
            >
              Ok
            </button>
          </div>
        </div>
      </ModalWrapper>
    );
  }
  return null;
};

OptionsFormModal.propTypes = {
  show: PropTypes.bool, // from confirmable. indicates if the dialog is shown or not.
  proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
  confirmation: PropTypes.string, // arguments of your confirm function
  options: PropTypes.object, // arguments of your confirm function
};

const OptionsFormModalConfirmable = confirmable(OptionsFormModal);
const confirm = createConfirmation(OptionsFormModalConfirmable);
export function pickOptions(confirmation, options = {}) {
  return confirm({ confirmation, options });
}
